import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { func, bool, number, arrayOf, shape, string, oneOfType } from 'prop-types';
import { Close } from '@magalu/stereo-ui-icons';
import { Container, Title, FilterBar, Backward, Clear, TitleSideCard } from './filter-menu.styles';
import { clearLabel, filterLabel } from './filter-menu.text';
import Counter from '../../molecules/Counter';
import { FilterItemAttribute, FilterItemReview, FilterItemContainer, Sidebar, FilterItemPrice } from '../../organisms';
import List from '../../molecules/List'; // eslint-disable-next-line react/display-name

export const renderCategoryFilterItem = categoryItemClick => (item, idx) => /*#__PURE__*/React.createElement(List.Item, _extends({}, item, {
  key: item.id || idx,
  href: item.path || item.href,
  onClick: (item.path || item.href) && (e => {
    categoryItemClick(e, item);
  }),
  fontWeight: !(item.path || item.href) ? 'bold' : undefined,
  as: (item.path || item.href) && 'a',
  startIcon: item.icon,
  endIcon: !item.icon && (item.path || item.href) && 'ChevronRight'
}), item.label);

const FilterMenu = ({
  onOpen,
  onClose,
  onClear,
  onClickOutside,
  onShowDetail,
  onItemClick,
  visible,
  filters,
  count
}) => {
  const {
    attributeFilter: attributeItemClick,
    reviewFilter: reviewItemClick,
    categoryFilter: categoryItemClick,
    priceFilter: priceApply
  } = onItemClick;

  const renderMultiple = ({
    slug,
    values,
    label,
    position,
    filterSelected,
    showFilterInput
  }) => /*#__PURE__*/React.createElement(FilterItemAttribute, {
    key: slug,
    items: values,
    label: label,
    position: position,
    onItemClick: attributeItemClick,
    filterSelected: filterSelected,
    showFilterInput: showFilterInput,
    fullScreen: true,
    onClick: onShowDetail
  });

  const renderHierarchical = ({
    position,
    label,
    values
  }) => /*#__PURE__*/React.createElement(FilterItemContainer, {
    label: label,
    position: position,
    fullScreen: true,
    onClick: onShowDetail
  }, /*#__PURE__*/React.createElement(List, null, values == null ? void 0 : values.map(renderCategoryFilterItem(categoryItemClick))));

  const renderUnique = ({
    slug,
    values,
    label,
    position,
    filterSelected,
    showFilterInput
  }) => /*#__PURE__*/React.createElement(FilterItemReview, {
    position: position,
    key: slug,
    items: values,
    label: label,
    onItemClick: reviewItemClick,
    filterSelected: filterSelected,
    showFilterInput: showFilterInput,
    fullScreen: true,
    onClick: onShowDetail
  });

  const renderPrice = item => {
    const {
      position,
      slug,
      label,
      min,
      max,
      selectedMin,
      selectedMax
    } = item;
    return /*#__PURE__*/React.createElement(FilterItemPrice, {
      position: position,
      key: slug,
      label: label,
      onApply: priceApply,
      fullScreen: true,
      onClick: onShowDetail,
      min: min,
      max: max,
      selectedMin: selectedMin,
      selectedMax: selectedMax,
      item: item
    });
  };

  const renderByType = {
    multiple: renderMultiple,
    hierarchical: renderHierarchical,
    unique: renderUnique,
    priceRange: renderPrice
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    onClick: onOpen,
    "data-testid": "filter-menu-button"
  }, /*#__PURE__*/React.createElement(Counter, {
    count: count,
    mr: '4px'
  }), /*#__PURE__*/React.createElement(Title, null, filterLabel)), /*#__PURE__*/React.createElement(Sidebar, {
    direction: "right",
    visible: visible,
    onClickOutside: onClickOutside
  }, /*#__PURE__*/React.createElement(FilterBar, null, /*#__PURE__*/React.createElement(Backward, {
    onClick: onClose,
    role: "button",
    tabIndex: "0",
    "data-testid": "close-menu"
  }, /*#__PURE__*/React.createElement(Close, {
    height: "20"
  })), /*#__PURE__*/React.createElement(TitleSideCard, null, filterLabel), /*#__PURE__*/React.createElement(Clear, {
    onClick: count >= 1 ? onClear : null,
    onKeyDown: count >= 1 ? onClear : null,
    role: "button",
    tabIndex: "-1",
    "data-testid": "clear-filters",
    count: count
  }, clearLabel)), /*#__PURE__*/React.createElement(React.Fragment, null, filters != null && filters.length ? filters.map(filterItem => {
    const {
      componentType
    } = filterItem;
    return renderByType[componentType](filterItem);
  }) : null)));
};

process.env.NODE_ENV !== "production" ? FilterMenu.propTypes = {
  onClear: func.isRequired,
  onClose: func.isRequired,
  onOpen: func.isRequired,
  onClickOutside: func.isRequired,
  onItemClick: shape({
    attributeFilter: func,
    reviewFilter: func
  }),
  onShowDetail: func,
  visible: bool,
  count: number,
  filters: shape({
    attributeFilters: arrayOf(shape({
      type: string,
      slug: string,
      label: string,
      values: arrayOf(shape({
        slug: string,
        label: string
      }))
    })),
    reviewFilters: shape({
      type: string,
      slug: string,
      label: string,
      values: arrayOf(shape({
        slug: oneOfType([string, number]),
        value: oneOfType([string, number])
      }))
    })
  })
} : void 0;
FilterMenu.defaultProps = {
  onClear: () => {},
  onClose: () => {},
  onOpen: () => {},
  onClickOutside: () => {},
  visible: false,
  filters: {
    attributeFilters: [],
    reviewFilter: {}
  },
  count: 0,
  onItemClick: {
    attributeFilter: () => ({}),
    reviewFilter: () => ({})
  },
  onShowDetail: () => {}
};
export default FilterMenu;